import { Controller } from "@hotwired/stimulus";

// Tracks the public report email-gate form: when a viewer submits their
// email (and optionally requests a PDF), we want to know — pg3h flagged
// this as an unmeasurable funnel step.
//
// Wired via data-controller="pdf-gate" on the form. Reads report_id /
// influencer_id from data attributes on the form's root element.
export default class extends Controller {
  static values = {
    reportId: String,
    influencerId: String,
  };

  static targets = ["downloadPdf"];

  connect() {
    this.capture("pdf_gate_shown");
  }

  submit() {
    var pdfRequested =
      this.hasDownloadPdfTarget && this.downloadPdfTarget.checked;
    this.capture("pdf_gate_submitted", { pdf_requested: pdfRequested });
  }

  capture(eventName, props = {}) {
    if (typeof window.posthog === "undefined") return;
    window.posthog.capture(eventName, {
      report_id: this.reportIdValue || null,
      influencer_id: this.influencerIdValue || null,
      ...props,
    });
  }
}
